import { arrow, downLogo, blogLogo, mainLogo, spLogo, blackMainLogo, blackDownLogo, blackBlogLogo, blackSpLogo, blackArrow, headerMenuIcon, headerMenuIconGray, referenceLogo, blackReferenceLogo } from '../assets/images/header/headerImages';
import { throttle } from 'lodash';

export const scrollToPage = (outerDivRef, pageHeight, dividerHeight, nextPage) => {
  if (outerDivRef && outerDivRef.current) {
    const targetScrollTop = (nextPage - 1) * (pageHeight + dividerHeight);
    outerDivRef.current.scrollTo({
      top: targetScrollTop,
      behavior: "smooth",
    });
  }
};

export const updateMainHeaderColor = (nextPage) => {
  const headerElements = document.querySelectorAll('#navMenu > li');
  const header = document.querySelector('.header');
  const headerLine = document.querySelector('#headerLine');
  const fixLine = document.querySelector('#main-fix-line');
  const headerTexts = document.querySelectorAll('.headerSmallText');
  const headerMainLogo = document.querySelector('#mainLogo');
  const headerDownLogo = document.querySelector('#downIcon');
  const headerReferenceLogo = document.querySelector('#referenceIcon');
  const headerBlogIcon = document.querySelector('#blogIcon');
  const headerSpIcon = document.querySelector('#spIcon');
  const headerIconLine = document.querySelector('#headerConLine');
  const headerArrows = document.querySelectorAll('.mainHeaderArrow');
  

  if ([0, 1, 3].includes(nextPage)) {
    headerElements.forEach(element => {
      element.style.color = 'white';
    });
    headerArrows.forEach(element => {
      element.src = arrow;
      element.style.marginLeft = '0px';
    });
    headerLine.style.backgroundColor = '#ffffff2e'
    fixLine.style.borderLeft = '1px solid rgba(255, 255, 255, 0.1)';
    header.style.backgroundColor = '';
    headerTexts.forEach(element => {
      element.style.color = 'white';
    });
    headerMainLogo.src = mainLogo;
    headerDownLogo.src = downLogo;
    headerReferenceLogo.src = referenceLogo;
    headerBlogIcon.src = blogLogo;
    headerSpIcon.src = spLogo;
    headerIconLine.style.backgroundColor = '#ffffff72';
  } else {
    headerElements.forEach(element => {
      element.style.color = 'black';
    });
    headerArrows.forEach(element => {
      element.src = blackArrow;
      element.style.marginLeft = '5px';
    });
    headerLine.style.backgroundColor = 'rgba(0, 0, 0, 0.30)';
    fixLine.style.borderLeft = '1px solid rgba(0, 0, 0, 0.30)';
    header.style.backgroundColor = 'white';
    headerTexts.forEach(element => {
      element.style.color = 'black';
    });
    headerMainLogo.src = blackMainLogo;
    headerDownLogo.src = blackDownLogo;
    headerReferenceLogo.src = blackReferenceLogo;
    headerBlogIcon.src = blackBlogLogo;
    headerSpIcon.src = blackSpLogo;
    headerIconLine.style.backgroundColor = 'black';
  }
  if (nextPage === 8) {
    fixLine.style.borderLeft = '1px solid rgba(255, 255, 255, 0.1)';
  }
};


export const updateMobileMainHeaderColor = (nextPage) => {
  const header = document.querySelector('.header');
  const headerMainLogo = document.querySelector('#mainLogo');
  const headerDownLogo = document.querySelector('#downIcon');
  const headerReferenceLogo = document.querySelector('#referenceIcon');
  const headerBlogIcon = document.querySelector('#blogIcon');
  const headerSpIcon = document.querySelector('#spIcon');
  const headerIconLine = document.querySelector('#headerConLine');
  const headerMenuBtn = document.querySelector('#heaer-menu-btn');
  
  if ([0, 1, 3].includes(nextPage + 1)) {
    header.style.backgroundColor = '';
    headerMainLogo.src = mainLogo;
    headerDownLogo.src = downLogo;
    headerReferenceLogo.src = referenceLogo;
    headerBlogIcon.src = blogLogo;
    headerSpIcon.src = spLogo;
    headerIconLine.style.backgroundColor = '#ffffff72';
    headerMenuBtn.src = headerMenuIcon;
  } else {
    header.style.backgroundColor = 'white';
    headerMainLogo.src = blackMainLogo;
    headerDownLogo.src = blackDownLogo;
    headerReferenceLogo.src = blackReferenceLogo;
    headerBlogIcon.src = blackBlogLogo;
    headerSpIcon.src = blackSpLogo;
    headerIconLine.style.backgroundColor = 'black';
    headerMenuBtn.src = headerMenuIconGray;
  }
};

export const calculateNextPage = throttle((deltaY, currentPage, totalPages) => {
  let nextPage = currentPage;
 
  if (deltaY > 0) {
    nextPage = currentPage < totalPages - 1 ? currentPage + 1 : currentPage;
  }
   else {
    nextPage = currentPage > 1 ? currentPage - 1 : currentPage;
  }

  return nextPage;
}, 800);
